import styled from 'styled-components';
import { theme } from '../../../../theme';

export const DivBreak = styled.div`
  flex-basis: 100%;
  width: 0;
`;

export const DivSubheader = styled.div`
  width: 100%;
  padding-bottom: 1.078rem;
  padding-left: 3.077rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  box-shadow: 0 3px 5px 0 rgba(25, 21, 69, 0.07);
  z-index: 2;
  position: relative;

  ${theme.up(theme.breakpoints.sm)} {
    flex-direction: row;
    align-items: center;
    padding-left: 0;
  }
`;

export const SpanArrow = styled.span`
  margin: 0 1.078rem;
  opacity: 0;

  svg {
    font-size: 1.3em;
    vertical-align: sub;
  }

  ${theme.up(theme.breakpoints.sm)} {
    opacity: 1;
  }
`;
